import type { FontSize, HeadingSize, TextSize } from '@mntn-dev/ui-theme'
import type { CSSProperties, PropsWithChildren } from 'react'

export type SkeletonProps = Readonly<
  PropsWithChildren<{
    className?: string
    style?: CSSProperties
    variant?: 'rectangle' | 'rounded'
  }>
>

export type SkeletonFontSize = FontSize
export type SkeletonTextSize = Extract<SkeletonFontSize, TextSize>
export type SkeletonHeadingSize = Extract<SkeletonFontSize, HeadingSize>

export const skeletonFontSizeMap: Record<SkeletonFontSize, string> = {
  '3xs': 'h-1.5',
  '2xs': 'h-2',
  xs: 'h-2.5',
  sm: 'h-3',
  base: 'h-3.5',
  lg: 'h-4',
  xl: 'h-5',
  '2xl': 'h-6',
  '3xl': 'h-7.5',
  '4xl': 'h-9',
  '5xl': 'h-12',
  display: 'h-16',
  displayXl: 'h-25',
}

export const skeletonLineGapMap: Record<SkeletonTextSize, string> = {
  '3xs': 'gap-y-0.5',
  '2xs': 'gap-y-0.5',
  xs: 'gap-y-1',
  sm: 'gap-y-1.5',
  base: 'gap-y-2',
  lg: 'gap-y-2.5',
}
